<template lang='pug'>
  i.svg-icon.svg-icon-doctor
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      circle(:fill='color' cx='50.103' cy='49.935' r='45.561')
      path(fill='#FFFFFF' d='M50,13.623c-7.839,0-14.215,6.378-14.215,14.217v7.366c0,7.839,6.376,14.217,14.215,14.217 c7.84,0,14.216-6.378,14.216-14.217V27.84C64.216,20,57.84,13.623,50,13.623z')
      path(fill='#FFFFFF' d='M81.35,67.949c-4.551-7.757-11.828-13.507-20.487-16.193c-0.201-0.062-0.417-0.009-0.567,0.139 c-4.028,3.973-9.033,7.07-10.285,7.819c-1.335-0.854-6.962-4.521-10.308-7.819c-0.149-0.147-0.368-0.2-0.567-0.139 c-8.661,2.687-15.936,8.438-20.486,16.194c-0.104,0.178-0.104,0.399,0,0.577c6.461,11.011,18.474,17.85,31.35,17.85 c12.877,0,24.89-6.839,31.351-17.85C81.455,68.348,81.455,68.127,81.35,67.949z M69.334,72.191c0,0.313-0.298,0.553-0.612,0.553 h-3.85c-0.313,0-0.656,0.271-0.656,0.585v3.98c0,0.313-0.168,0.553-0.48,0.553h-3.458c-0.314,0-0.61-0.239-0.61-0.553v-3.98 c-0.001-0.314-0.214-0.585-0.528-0.585h-4.017c-0.313,0-0.573-0.239-0.573-0.553v-3.429c0-0.313,0.26-0.567,0.573-0.567h4.017 c0.314,0,0.527-0.256,0.527-0.57v-3.986c0-0.313,0.296-0.561,0.609-0.561h3.421c0.313,0,0.52,0.247,0.52,0.561v3.998 c0,0.314,0.304,0.558,0.618,0.558h3.888c0.314,0,0.612,0.266,0.612,0.579V72.191z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
